
      import { ConsoleLogger } from "/main.js";

      const logger = new ConsoleLogger(document.getElementById("output"));
      const metricsDiv = document.getElementById("metrics");
      const slowButton = document.getElementById("slowButton");
      const clearBtn = document.getElementById("clearBtn");

      // Configurar Event Timing API para medir interacciones
      const eventObserver = new PerformanceObserver((list) => {
        for (const entry of list.getEntries()) {
          // Solo nos interesan las interacciones lentas (>100ms)
          // Esto filtra automáticamente el botón de limpiar
          if (entry.interactionId && entry.duration > 100) {
            const duration = entry.duration;
            const processingTime = entry.processingEnd - entry.processingStart;

            logger.log("🔴 Interacción detectada (Event Timing API):");
            logger.log(`   • Tipo: ${entry.name}`);
            logger.log(`   • Duración total: ${duration}ms`);
            logger.log(`   • Tiempo de procesamiento: ${processingTime}ms`);
            logger.log(`   • Inicio: ${entry.startTime}ms`);
            logger.log(`   • Processing start: ${entry.processingStart}ms`);
            logger.log(`   • Processing end: ${entry.processingEnd}ms`);
            logger.log("");

            // Evaluar INP
            let rating = "good";
            let ratingText = "Bueno";
            if (duration > 500) {
              rating = "poor";
              ratingText = "Malo";
            } else if (duration > 200) {
              rating = "needs-improvement";
              ratingText = "Necesita mejora";
            }

            logger.warn(`⚠️  INP Rating: ${ratingText} (${duration}ms)`);
            logger.warn("❓ Pero... ¿qué código específico causó esta lentitud?");
            logger.log("");

            // Mostrar métrica visual
            metricsDiv.innerHTML = `
            <div class="metric ${rating}">
              INP: ${duration}ms
              <small style="display: block; font-weight: normal; margin-top: 4px;">
                Sin contexto de qué lo causó
              </small>
            </div>
          `;
          }
        }
      });

      eventObserver.observe({
        type: "event",
        buffered: true,
        durationThreshold: 100, // Solo capturar interacciones lentas
      });

      // Simular un event handler complejo y lento
      slowButton.addEventListener("click", function handleSlowClick() {
        logger.log("👆 Click detectado, procesando...");

        // Función 1: Cálculo "pesado"
        heavyCalculation();

        // Función 2: Actualizar UI
        updateUserInterface();

        // Función 3: Tracking (simulado)
        trackEvent();

        logger.log("✅ Procesamiento completado");
        logger.log("⏳ Esperando datos de Event Timing API...");
        logger.log("");
      });

      // Simulaciones de funciones que podrían ser lentas
      function heavyCalculation() {
        // Bloquear el main thread por ~150ms
        const start = performance.now();
        while (performance.now() - start < 150) {
          Math.random() * Math.random();
        }
      }

      function updateUserInterface() {
        // Simular actualización DOM (50ms)
        const start = performance.now();
        while (performance.now() - start < 50) {
          Math.random() * Math.random();
        }
        slowButton.textContent = "Click procesado ✓";
        setTimeout(() => {
          slowButton.textContent = "Hacer clic aquí (será lento)";
        }, 1000);
      }

      function trackEvent() {
        // Simular tracking (30ms)
        const start = performance.now();
        while (performance.now() - start < 30) {
          Math.random() * Math.random();
        }
      }

      // Función para mostrar mensaje inicial
      function showInitialMessage() {
        logger.log("👋 Haz clic en el botón para ver cómo Event Timing API mide la interacción");
        logger.log("📌 Observa que sabremos QUE fue lento, pero no POR QUÉ");
        logger.log("");
      }

      // Limpiar consola
      clearBtn.addEventListener("click", () => {
        logger.clear();
        metricsDiv.innerHTML = "";
        showInitialMessage();
      });

      // Mensaje inicial
      showInitialMessage();
    